module.exports = __webpack_public_path__ + "static/auril-symbol-SCAG-0dd9069cb467624c815b33cf8338ac5a.webp";